//export const API_URL = "http://127.0.0.1:12000/";
export const API_URL = "https://testnet-backend.galapago.app/";
